'use strict'

var tagString = require('./tagString')
var parse = require('./parse')

module.exports = function tag (/* [literals], ...substitutions */) {
  return parse(tagString.apply(null, arguments))
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/ltx/lib/tag.js
// module id = 130
// module chunks = 0